module.exports = __webpack_public_path__ + "static/media/plus.5592a52e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Exchange/scenes/Success/img/plus.svg
// module id = 133
// module chunks = 0